<script>
  import acompanhamentoServico from '../servico';
  import DadosCadastrais from './compartilhado/FormDadosCadastraisAcomp.vue';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';

  export default {
    components: { DadosCadastrais, AdicionarArquivos, ListaDeArquivos },
    data() {
      return {
        mostrarFormulario: false,
        acompanhamentoProjeto: this.camposAcompanhamento(),
        carregando: true,
        configuracao: this.$storage.configuracao(),
        arquivos: [], 
      }
    },
    mounted() {
      this.$root.tituloDaPagina = 'Acompanhamento Projeto - Editar #' + this.$route.params.idAcompanhamento;
      this.$root.botaoAcaoMostrar = false;
    },
    methods: {
      salvar() {
        $('#salvar').button('loading');
        
        this.$refs.dadosCadastrais
          .validarDados()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
            }

            return valido;
          })
          .then(this.enviar)
          .then(() => this.$router.push({ name: 'acompanhamento-projeto' }))
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao salvar o acompanhamento do projeto.');
          });
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        const copiaAcompanhamento = JSON.parse(JSON.stringify(this.acompanhamentoProjeto));

        copiaAcompanhamento.arquivosDeletados = this.$refs.listaArquivos.deletados;

        return acompanhamentoServico.alterar(copiaAcompanhamento, this.$refs.adicionarArquivos.arquivos, this.$route.params.id);
      },
      camposAcompanhamento() {
        return {
          idAcompanhamentoProjeto: null,
          idProjeto: null,
          numeroRelatorio: '',
          periodoRelatorioInicio: '',
          periodoRelatorioFim: '',
          previsaoConclusao: '',
          atividadesIniciadas: "false",
          atividadesIniciadasJustificativa: '',
          cronogramaCumprido: "false",
          cronogramaCumpridoJustificativa: '',
          planoOrcamentoCumprido: "false",
          planoOrcamentoCumpridoJustificativa: '',
          normasRespeitadas: "false",
          normasRespeitadasJustificativa: '',        
          intercorrencia: "false",
          intercorrenciaJustificativa: '',
          comentariosAdicionais: '',
          dataAssinatura: '',
          idAssinatura: null,
          projeto: {
            idProjeto: '',
            nomeProjeto: '',
          },
        };
      },
      carregar(id) {
        this.carregando = true;

        let acompanha = null;

        acompanhamentoServico
          .obterPorId(id)
          .then(dados => {
            acompanha = dados;
          })
          .then(() => acompanhamentoServico.arquivos(acompanha.idAcompanhamentoProjeto))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.$set(this, 'acompanhamentoProjeto', acompanha);
            this.carregando = false;
          });
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
      download(arquivo) {
        acompanhamentoServico
          .download(this.$route.params.idAcompanhamento, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
    },
    created() {
      if (this.$route.params.id) {
        this.$set(this, 'mostrarFormulario', true);
        this.carregar(this.$route.params.id);
      }
    },
    watch: {
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form>

      <div class="row" v-if="mostrarFormulario">
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>

          <div class="tabs-container" v-show="!carregando" id="tabs">
            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-dados-cadastrais">
                  Questionário
                </a>
              </li>

              <li v-if="configuracao.pastaBaseAcompanhamentoProjeto !== ''">
                <a data-toggle="tab"
                   href="#tab-adicionar-arquivos">
                  Adicionar arquivos
                </a>
              </li>

              <li v-if="$route.params.id && (configuracao.pastaBaseAcompanhamentoProjeto !== '')">
                <a data-toggle="tab"
                   href="#tab-lista-arquivos">
                  Arquivos
                </a>
              </li>
            </ul>
            <div class="tab-content">

              <div id="tab-dados-cadastrais" class="tab-pane active">
                <div class="panel-body">
                  <dados-cadastrais ref="dadosCadastrais"
                                    :acompanhamento="acompanhamentoProjeto"
                                    :edicao="!!$route.params.id"
                                    :readonly="!!acompanhamentoProjeto.idAssinatura">
                  </dados-cadastrais>
                </div>
              </div>

              <div id="tab-adicionar-arquivos" class="tab-pane">
                <div class="panel-body">
                  <adicionar-arquivos ref="adicionarArquivos">
                  </adicionar-arquivos>
                </div>
              </div>

              <div id="tab-lista-arquivos" class="tab-pane">
                <div class="panel-body">
                  <lista-de-arquivos :arquivos="arquivos"
                                     @download="download"
                                     ref="listaArquivos">
                  </lista-de-arquivos>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">    
            <router-link class="btn btn-default"
                         :to="{ name: 'acompanhamento-projeto' }"
                         v-show="!mostrarFormulario || !!$route.params.id"
                         active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button 
                type="button" 
                class="btn btn-default" 
                @click="resetarComponente()" 
                v-show="mostrarFormulario && !(!!$route.params.id)">
              <i class="fa fa-arrow-left"></i>
              Volta 
            </button>

            <button 
                id="salvar"
                type="button" 
                class="btn btn-primary" 
                @click="salvar" 
                v-show="mostrarFormulario"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar 
            </button>
          </div>
        </div>
      </div>
      
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/acompanhamento-projeto/componentes/AcompanhamentoProjetoForm.vue